import logoAsset from '@assets/images/avantor_logotipo.png'

export const HeaderLogo = (): JSX.Element => {
  return <img src={logoAsset} alt="Avantor" height={42} />
}
